export default __webpack_public_path__ + "static/media/binance.38972faa.svg";